import { OverlayPage } from '@client/components/_core/layout/OverlayPage';
import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { trpc } from '@client/trpc/client';
import { createFileRoute } from '@tanstack/react-router';
import { Skeleton } from 'antd';
import { FinancialsDraftProvider, useFinancialsDraft } from './financials-draft';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/product-types/financials/$id')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Sections',
        },
    },
    params: {
        parse({ id }) {
            return {
                id: BigInt(id),
            };
        },
    },
    component: FinancialsConfiguration,
});

function FinancialsConfiguration() {
    const { id } = Route.useParams();
    const { data, isPending } = trpc.productType.getProductType.useQuery({ id });
    const navigate = useNavigate();
    // The Tax tab is a form saved by its own button, and a section title can be open for editing.
    const draft = useFinancialsDraft();

    return (
        <PageController route={Route}>
            <OverlayPage
                isDirty={draft.isDirty}
                loading={isPending}
                title={isPending ? <Skeleton.Node active className="h-6 w-60" /> : `Claim financials - ${data?.name}`}
                size="large"
                afterClose={() => navigate({ moveInMatches: -1 })}
            >
                <FinancialsDraftProvider register={draft.register}>
                    <Tabs
                        items={[
                            {
                                to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/sections',
                                label: 'Sections',
                            },
                            {
                                to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/transaction-types',
                                label: 'Transaction types',
                            },
                            {
                                to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/cost-codes',
                                label: 'Cost codes',
                            },
                            {
                                to: '/console/$orgId/configuration/claims-products/product-types/financials/$id/tax',
                                label: 'Tax',
                            },
                        ]}
                    />
                </FinancialsDraftProvider>
            </OverlayPage>
        </PageController>
    );
}
